import { initialsFromString } from '@apps-common/helpers/initials-from-string'
import { useAvatarColors } from '@apps-common/hooks/useAvatarColors'
import { ImageComponent } from './Image'

interface IProps {
  siteName?: string
  url: string | null | undefined
  file: any
  loading?: boolean
}

export const SiteDetailsImage = ({ siteName, url, file, loading }: IProps) => {
  console.log('Site details url: ', url)
  const { getAvatarColors } = useAvatarColors()

  if (loading) {
    return <div className='w-[60px] h-[60px] rounded-full bg-skeleton border border-skeleton-border animate-pulse' />
  }

  if (file) {
    return (
      <img
        src={URL.createObjectURL(file?.blob || file)}
        alt='New selected'
        className='w-[60px] h-[60px] rounded-full border-[1px] border-primary-content'
      />
    )
  }

  if (url) {
    return (
      <ImageComponent
        src={url}
        alt='Site thumbnail'
        containerClasses='w-[60px] h-[60px] rounded-full bg-skeleton'
        imageClasses='w-[60px] h-[60px] rounded-full border-[1px] border-primary-content'
      />
    )
  }

  const initials = initialsFromString(siteName) || 'SD'
  const colors = getAvatarColors(initials)
  return (
    <div
      className={'w-[60px] h-[60px] border rounded-full jost-medium text-[20px] flex items-center justify-center'}
      style={{
        backgroundColor: colors.backgroundColor,
        color: colors.color,
        borderColor: colors.borderColor
      }}
    >
      {initials}
    </div>
  )
}
